import {IdValue} from './id-value';

export class GroupEntry {
  constructor(public id: number,
              public title: string,
              public vehicles: IdValue<string>[]) {

  }
}
